<template>
	<div id="app">
		<v-HeadBar></v-HeadBar>
		
		<router-view v-if="isRouterAlive"></router-view>
		<v-Footer></v-Footer>
	</div>
</template>

<script>
	import vHeadBar from './components/Header.vue'
	import vFooter from './components/Footer.vue'
	

	export default {
		name: 'app',
		
		provide(){
			return{
				reload:this.reload
			}
		},
		
		components: {
			vHeadBar,
			vFooter
		},
		data() {
			return {
				isRouterAlive:true
			}
		},
		methods: {
			/*change(title) {
			    this.title = title;

			}*/
			reload(){
				this.isRouterAlive=false
				this.$nextTick(function(){
					this.isRouterAlive=true
				})
			}

		}
	}
</script>

</style>


// WEBPACK FOOTER //
// src/App.vue